// extracted by mini-css-extract-plugin
export default {"container":"TextHighlighter_container__uPVp8","likeAnimation":"TextHighlighter_likeAnimation__JfU7-"};